'use client';
import { usePathname } from 'next/navigation';
import { ProductPopup } from '@/components/features/products/product-popup/product-popup';
import { StorefrontProductPopup } from './product-popup';

export function ProductPopupRouter() {
  return usePathname() === '/' ? <StorefrontProductPopup /> : <ProductPopup />;
}
